// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* mat-button-toggle-group {
  left: 21.7%;
  position: relative;
} */
.mt-26 {
  margin-top: 26px;
}

.mat-step-icon-theme {
  text-align: center;
  color: #008fc7;
  font-size: 3.7rem;
}

.mat-step-text-theme {
  text-align: center;
  color: #008fc7;
  font-size: 1.1rem;
  font-weight: 500;
}

/*.mat-stepper-theme{
    height:100px !important
}*/

::ng-deep .mat-stepper-theme .mat-step-header {
  height: 100px !important;
}

::ng-deep .mat-horizontal-stepper-header {
  pointer-events: none !important;
}

.fieldset-box {
  padding: 0 15px 15px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
}

/* ::ng-deep .cuppa-dropdown.dropdown-list{
  position: relative !important;
  padding-top: 14px!important;
  width: 100%!important;
  z-index: 0!important;
} */
.dropdown-list {
  position: relative !important;
  padding-top: 14px !important;
  width: 100% !important;
  z-index: 0 !important;
}




.reqierd {
  border: 1px solid red;
}

::ng-deep angular2-multiselect .tagToBody {
  position: fixed !important;
}

._formHight{

  height: 1000px;
  min-height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/app/views/notifications/add-notifications/add-notifications.component.css"],"names":[],"mappings":"AAAA;;;GAGG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;;;GAKG;AACH;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;AACvB;;;;;AAKA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* mat-button-toggle-group {\r\n  left: 21.7%;\r\n  position: relative;\r\n} */\r\n.mt-26 {\r\n  margin-top: 26px;\r\n}\r\n\r\n.mat-step-icon-theme {\r\n  text-align: center;\r\n  color: #008fc7;\r\n  font-size: 3.7rem;\r\n}\r\n\r\n.mat-step-text-theme {\r\n  text-align: center;\r\n  color: #008fc7;\r\n  font-size: 1.1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n/*.mat-stepper-theme{\r\n    height:100px !important\r\n}*/\r\n\r\n::ng-deep .mat-stepper-theme .mat-step-header {\r\n  height: 100px !important;\r\n}\r\n\r\n::ng-deep .mat-horizontal-stepper-header {\r\n  pointer-events: none !important;\r\n}\r\n\r\n.fieldset-box {\r\n  padding: 0 15px 15px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 10px;\r\n}\r\n\r\n/* ::ng-deep .cuppa-dropdown.dropdown-list{\r\n  position: relative !important;\r\n  padding-top: 14px!important;\r\n  width: 100%!important;\r\n  z-index: 0!important;\r\n} */\r\n.dropdown-list {\r\n  position: relative !important;\r\n  padding-top: 14px !important;\r\n  width: 100% !important;\r\n  z-index: 0 !important;\r\n}\r\n\r\n\r\n\r\n\r\n.reqierd {\r\n  border: 1px solid red;\r\n}\r\n\r\n::ng-deep angular2-multiselect .tagToBody {\r\n  position: fixed !important;\r\n}\r\n\r\n._formHight{\r\n\r\n  height: 1000px;\r\n  min-height: 300px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
